import { importRetry } from "@common/import-retry";
import { Product } from "@product-pages/common/types";
import React from "react";

// https://confluence.platform.vwfs.io/display/SPR/NeCSt+%7C+Direct+Credit
// https://confluence.platform.vwfs.io/display/SPR/DC+-+Content+Sheets

export const NECST_DCC: Product = {
  productPath: "/ratenkredit",
  productId: "DCC",
  component: React.lazy(() => importRetry(() => import("./RatenkreditPages"))),
};

export const NECST_DAC: Product = {
  productPath: "/autokredit",
  productId: "DAC",
  component: React.lazy(() => importRetry(() => import("./AutokreditPages"))),
};
